let lockCount = 0
let scrollbarWidth = 0

function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth
}

export function lockScroll() {
  if (lockCount === 0) {
    scrollbarWidth = getScrollbarWidth()
    document.body.style.overflow = 'hidden'
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`
    }
  }
  lockCount++
}

export function unlockScroll() {
  if (lockCount > 0) {
    lockCount--
  }
  if (lockCount === 0) {
    document.body.style.overflow = ''
    document.body.style.paddingRight = ''
  }
}
